import appClient from '../../common/services/AppClient';
import InferenceModel from '../types';
import { Connection } from '../models';
import { endpoints } from '../../../config';

export default class InferenceModelsService {
    async getModels(projectId?: string, type?: string[]): Promise<InferenceModel[]> {
        if (!projectId) {
            throw new Error('Project id is required to load inference models.');
        }

        const result = await appClient.get<InferenceModel[]>(this.getModelsUrl(projectId, type));
        if (result.isErr()) {
            console.log(result.error);
            throw result.error;
        }

        return result.value;
    }

    async getConnections(): Promise<Connection[]> {
        return [];
    }

    private getModelsUrl(projectId?: string, type?: string[]) {
        const baseUrl = `${endpoints.manageUrl}projects/${projectId}/inference_models`;
        const typeQuery = (type || []).map(t => `type=${encodeURIComponent(t)}`).join('&');
        return typeQuery ? `${baseUrl}?${typeQuery}` : baseUrl;
    }
}
